import { QueryClient } from '@tanstack/react-query';
import { DEFAULT_CACHE_TIME_MS } from 'common/constants/caching.constants';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: DEFAULT_CACHE_TIME_MS,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});
